import api from '../request'

export function login(params) {
    return api({
        method: 'POST',
        url: '/login',
        params: params
    })
}

export function logout(params) {
    return api({
        method: 'GET',
        url: '/logout',
        params: params
    })
}

export function list(params) {
    return api({
        method: 'POST',
        url: '/menu/list',
        params: params
    })
}

export function add(params) {
    return api({
        method: 'POST',
        url: '/user/save',
        params: params
    })
}

export function update(params) {
    return api({
        method: 'POST',
        url: '/user/update',
        params: params
    })
}

export function moduleDelete(params) {
    return api({
        method: 'POST',
        url: '/user/delete',
        params: params
    })
}

export function moduleSelect(params) {
    return api({
        method: 'POST',
        url: '/user/visibleUserList',
        // url: '/user/list',
        params: params
    })
}

export function resetPassword(params) {
    return api({
        method: 'POST',
        url: '/user/resetPasswd',
        params: params
    })
}

export function sendCode(params) {
    return api({
        method: 'POST',
        url: '/sendCode',
        params: params
    })
}

export function verifyReset(params) {
    return api({
        method: 'POST',
        url: '/verifyReset',
        params: params
    })
}

// 查询机构
export function orgList(params) {
    return api({
        method: "POST",
        url: "/user/orgList",
        params: params
    });
}


// WEBPACK FOOTER //
// ./src/comon/api/home.js